export const contactsData = {
    email: '55pramuditha@gmail.com',
    phone: '+94771230577',
    address: 'Tissamaharama, Sri Lanka (82600) ',

    sheetAPI: ''
}